import { useState } from 'react'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Divider, Grid, Typography } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const OrderContainer = ({ title, children }: { title: string; children: React.ReactNode }) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const [expanded, setExpanded] = useState<boolean>(true)

  return (
    <Grid container={true} sx={classes.orderContainer} data-testid={`${title}-container`}>
      <Grid
        container={true}
        onClick={() => setExpanded(!expanded)}
        size={12}
        sx={[sharedClasses.centerContentVertical, { gap: 1 }, classes.orderContainerButton]}
      >
        {expanded ? <ExpandMore sx={classes.orderContainerExpandIcon} /> : <ExpandLess />}
        <Typography variant="subtitle1">{title}</Typography>
      </Grid>
      {expanded && (
        <>
          <Grid size={12}>
            <Divider />
          </Grid>

          <Grid sx={classes.orderContainerChildWrapper} size={12}>
            {children}
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default OrderContainer
